module.exports = "https://static.im-cdn.com/mjc/storefront/Accent/static/media/LAccount.9f8d5e1b.svg";